import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as VisibilityIcon } from 'Assets/svg/visibility.svg';
import { ReactComponent as VisibilityOffIcon } from 'Assets/svg/visibility-off.svg';
import CommonPopupWrapperComponent from 'Components/common/commonPopupWrapperComponent';
import CancelSaveButton from 'Components/common/CancelSaveButton';
import profileState from 'Stores/profile';
import './changePasswordPopup.scss';

const PasswordFieldWithVisibilityIcon = props => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <span className="input-with-icon">
      <input
        {...props}
        type={showPassword ? 'text' : 'password'}
        spellCheck="false"
      />
      {showPassword ? (
        <VisibilityOffIcon onClick={() => setShowPassword(!showPassword)} />
      ) : (
        <VisibilityIcon onClick={() => setShowPassword(!showPassword)} />
      )}
    </span>
  );
};

const ChangePasswordSection = observer(props => {
  const { values, setValues, errors, setErrors } = props;
  return (
    <form>
      <label htmlFor="current-password">
        Current Password
        <PasswordFieldWithVisibilityIcon
          id="current-password"
          type="password"
          className={
            errors.currentPassword !== '' || profileState.currentPasswordError
              ? 'input-error'
              : ''
          }
          placeholder="Enter current password"
          value={values.currentPassword}
          onBlur={() => {
            if (values.currentPassword)
              profileState.checkCurrentPassword(values.currentPassword);
          }}
          onChange={e => {
            setValues({ ...values, currentPassword: e.target.value });
          }}
        />
        {(errors.currentPassword || profileState.currentPasswordError) && (
          <div className="error">
            {profileState.currentPasswordError && values.currentPassword !== ''
              ? 'Please check your password'
              : errors.currentPassword}
          </div>
        )}
      </label>
      <label htmlFor="new-password">
        New Password
        <PasswordFieldWithVisibilityIcon
          id="new-password"
          type="password"
          placeholder="Enter new password"
          className={errors.newPassword !== '' ? 'input-error' : ''}
          value={values.newPassword}
          onChange={e => {
            setValues({ ...values, newPassword: e.target.value });
            if (errors.newPassword)
              setErrors({
                ...errors,
                newPassword:
                  (e.target.value || '').length < 6
                    ? 'Password must be atleast 6 characters'
                    : '',
              });
          }}
        />
        {errors.newPassword && (
          <div className="error">{errors.newPassword}</div>
        )}
      </label>
      <label htmlFor="confirm-password">
        Confirm Password
        <PasswordFieldWithVisibilityIcon
          id="confirm-password"
          type="password"
          className={errors.confirmNewPassword !== '' ? 'input-error' : ''}
          placeholder="Enter new password again"
          value={values.confirmNewPassword}
          onChange={e => {
            setValues({ ...values, confirmNewPassword: e.target.value });
            if (errors.confirmNewPassword)
              setErrors({
                ...errors,
                confirmNewPassword:
                  values.newPassword !== e.target.value
                    ? 'Passwords do not match'
                    : '',
              });
          }}
        />
        {errors.confirmNewPassword && (
          <div className="error">{errors.confirmNewPassword}</div>
        )}
      </label>
    </form>
  );
});

const ChangePasswordPopup = props => {
  const { onClose } = props;
  const [values, setValues] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [errors, setErrors] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const state = {
    values,
    setValues,
    errors,
    setErrors,
  };

  let newErrorState = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  };
  
  const handleSave = () => {
    ['currentPassword', 'newPassword', 'confirmNewPassword'].some(key => {
      if (values[key].length === 0) {
        newErrorState = {
          ...errors,
          [key]: `Please enter ${
            key === 'currentPassword'
              ? 'current password'
              : key === 'newPassword'
              ? 'new password'
              : 'new password again'
          }`,
        };
        return true;
      }
      if (key === 'newPassword')
        if (values[key].length < 6) {
          newErrorState = {
            ...errors,
            [key]: 'Password must be atleast 6 characters',
          };
          return true;
        }
      if (
        key === 'confirmNewPassword' &&
        values.newPassword !== values.confirmNewPassword
      ) {
        newErrorState = {
          ...errors,
          [key]: 'Passwords do not match',
        };
        return true;
      }

      return false;
    });
    const isValid = Object.keys(newErrorState).every(key => {
      return newErrorState[key] === '';
    });
    setErrors(newErrorState);
    if (isValid && !profileState.currentPasswordError)
      profileState.updatePassword(
        {
          newPassword: values.newPassword,
          currentPassword: values.currentPassword,
        },
        onClose,
      );
  };

  return (
    <CommonPopupWrapperComponent
      showCloseBtn
      titleText="Change Password"
      content={<ChangePasswordSection {...state} />}
      actionBtn={
        <CancelSaveButton handleSave={handleSave} handleCancel={onClose} />
      }
      customParentClass="change-password-popup"
      closeClickCallback={onClose}
      clickOutsidePopupCallback={onClose}
    />
  );
};

export default ChangePasswordPopup;
